import { render } from "./price_list.vue?vue&type=template&id=58152b97&scoped=true"
import script from "./price_list.vue?vue&type=script&lang=js"
export * from "./price_list.vue?vue&type=script&lang=js"

import "./price_list.vue?vue&type=style&index=0&id=58152b97&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58152b97"]])

export default __exports__